import { render, staticRenderFns } from "./login-empty.vue?vue&type=template&id=0fc63f1e&"
import script from "./login-empty.vue?vue&type=script&lang=js&"
export * from "./login-empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CImage: require('@chakra-ui/vue').CImage, CText: require('@chakra-ui/vue').CText, CButton: require('@chakra-ui/vue').CButton, CFormControl: require('@chakra-ui/vue').CFormControl, CBox: require('@chakra-ui/vue').CBox, CFlex: require('@chakra-ui/vue').CFlex, CAlertIcon: require('@chakra-ui/vue').CAlertIcon, CAlertDescription: require('@chakra-ui/vue').CAlertDescription, CAlert: require('@chakra-ui/vue').CAlert})
